// extracted by mini-css-extract-plugin
export default {"background_pic":"ApprovalDetail_background_pic__dsceO"};